import { Injectable } from '@angular/core';
import { ConfigService } from './config/config.service';
import { UserAccountService } from './user-account.service';

@Injectable({
    providedIn: 'root',
})
export class CheckTokensService {
    constructor(
        private userAccountService: UserAccountService,
        private readonly configService: ConfigService
    ) {}

    async performCheck(): Promise<any> {
        const url = new URL(window.location.href);
        const customerID = [...url.searchParams].find(([k]) => k.toLowerCase() === 'dsid')?.[1] ?? null;
        // Below NOSONAR comment is to escape from SonarCloud Code Analysis
        const customerIdWithoutPrefix = customerID?.replace(/.*?(\d+)/, '$1'); //NOSONAR
        if (customerIdWithoutPrefix) {
            const origin = this.configService.config.authService;
            // Client Auth URL which routes to CheckTokens with customer id as route parameter
            const url = `${origin}/CheckTokens/${customerIdWithoutPrefix}`;
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);

            const handleMessage = (event: MessageEvent) => {
                if (event?.origin === origin) {
                    const { result, data } = event?.data;
                    if (result === 'success' && data?.idToken && data?.accessToken && data?.refreshToken) {
                        this.userAccountService
                            .login(data.idToken, data.accessToken, data.refreshToken, customerIdWithoutPrefix)
                            .subscribe({
                                complete: () => {
                                    // Once successfully completed, Remove iframe and listener
                                    this.removeHandlers(iframe, handleMessage);
                                },
                            });
                    } else {
                        this.removeHandlers(iframe, handleMessage);
                    }
                }
            };

            window.addEventListener('message', handleMessage);
        }
    }

    private removeHandlers(iframe: HTMLIFrameElement, handleMessage: (event: MessageEvent) => void) {
        window.removeEventListener('message', handleMessage);
        document.body.removeChild(iframe);
    }
}
